import { render, staticRenderFns } from "./MonitoringSystem.vue?vue&type=template&id=d480adb6&scoped=true"
import script from "./MonitoringSystem.vue?vue&type=script&lang=js"
export * from "./MonitoringSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d480adb6",
  null
  
)

export default component.exports